function initCustomReviewsGrid() {
  var reviews = document.querySelectorAll('.custom-reviews-grid .review-block');
  var showMoreBtn = document.querySelector('.custom-reviews-grid__show-more-link');
  var filterSelect = document.getElementById('reviews-rating-filter');
  var reviewsToShow = 6;
  var filteredReviews = Array.from(reviews);

  function updateReviewsVisibility() {
    filteredReviews.forEach(function(review, idx) {
      if (idx < reviewsToShow) {
        review.style.display = '';
      } else {
        review.style.display = 'none';
      }
    });
    // Hide all non-filtered reviews
    reviews.forEach(function(review) {
      if (!filteredReviews.includes(review)) {
        review.style.display = 'none';
      }
    });
    if (reviewsToShow >= filteredReviews.length) {
      if (showMoreBtn) showMoreBtn.style.display = 'none';
    } else {
      if (showMoreBtn) showMoreBtn.style.display = '';
    }
  }

  function filterReviews() {
    var val = filterSelect ? filterSelect.value : 'all';
    if (val === 'all') {
      filteredReviews = Array.from(reviews);
    } else {
      filteredReviews = Array.from(reviews).filter(function(review) {
        return review.getAttribute('data-rating') === val;
      });
    }
    reviewsToShow = 6;
    updateReviewsVisibility();
  }

  if (filterSelect) {
    filterSelect.addEventListener('change', function() {
      filterReviews();
    });
  }

  filterReviews();

  if (showMoreBtn) {
    showMoreBtn.addEventListener('click', function(e) {
      e.preventDefault();
      reviewsToShow += 6;
      updateReviewsVisibility();
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomReviewsGrid);
} else {
  initCustomReviewsGrid();
}
